var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "category-description" },
    [
      _c("transition", { attrs: { mode: "out-in" } }, [
        !_vm.showMore && _vm.sentences.length > 2
          ? _c("p", {
              staticClass: "category-description-short",
              domProps: {
                innerHTML: _vm._s(
                  (_vm.descriptionShort = this.description.split("</p>")[0])
                )
              }
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.showMore || _vm.sentences.length <= 2
          ? _c("p", {
              staticClass: "category-description-long",
              domProps: { innerHTML: _vm._s(_vm.description) }
            })
          : _vm._e()
      ]),
      _vm._v(" "),
      !_vm.showMore && _vm.sentences.length > 2
        ? _c(
            "p",
            {
              staticClass: "btn btn--small btn--dark-blue button-outline",
              on: {
                click: function($event) {
                  _vm.showMore = true
                }
              }
            },
            [_vm._v("\n    Rozwiń opis\n  ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showMore && _vm.sentences.length > 2
        ? _c(
            "p",
            {
              staticClass: "btn btn--small btn--dark-blue button-outline",
              on: {
                click: function($event) {
                  _vm.showMore = false
                }
              }
            },
            [_vm._v("\n    Zwiń opis\n  ")]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }